<div class="page">
  @if (event(); as currentEvent) {
  <div class="mb-6">
    <button type="button" appBackNavigation class="back-link mb-5">
      <svg class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5" aria-hidden="true">
        <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" />
      </svg>
      {{ 'raceDetail.back' | translate }}
    </button>
    <div class="card event-hero relative overflow-hidden">
      @if(currentEvent.imageUrl) {
      <img [src]="currentEvent.imageUrl" [alt]="currentEvent.name" class="w-full h-48 md:h-56 object-cover">
      <div class="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent"></div>
      } @else {
      <img src="/assets/race-default-trail.webp" [alt]="currentEvent.name" class="w-full h-48 md:h-56 object-cover">
      }
      <app-brand-logo class="pointer-events-none absolute right-4 top-4 h-28 w-28 text-accent opacity-[0.07]" />
      <div class="relative z-[1] p-6" [class.absolute]="currentEvent.imageUrl" [class.bottom-0]="currentEvent.imageUrl"
        [class.left-0]="currentEvent.imageUrl" [class.right-0]="currentEvent.imageUrl">
        @if (isEditMode()) {
           <div class="space-y-4">
              <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                 <div>
                    <label class="field-label">{{ 'common.event' | translate }}</label>
                    <input type="text" [value]="currentEvent.name" (change)="updateEventInfo('name', $event)"
                       class="field py-2">
                 </div>
                 <div>
                    <label class="field-label">{{ 'common.historicalLocation' | translate }}</label>
                    <input type="text" [value]="currentEvent.location" (change)="updateEventInfo('location', $event)"
                       class="field py-2">
                 </div>
              </div>
              <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                 <div>
                    <label class="field-label">{{ 'common.date' | translate }}</label>
                    <input type="date" [value]="currentEvent.date.split('T')[0]" (change)="updateEventInfo('date', $event)"
                       class="field py-2">
                 </div>
                 <div>
                    <label class="field-label">{{ 'common.region' | translate }}</label>
                    <select [value]="currentEvent.region" (change)="updateEventInfo('region', $event)"
                       class="field py-2">
                       <option value="">{{ 'common.selectRegion' | translate }}</option>
                       @for (r of [
                        'AUVERGNE-RHÔNE-ALPES', 'BOURGOGNE-FRANCHE-COMTÉ', 'BRETAGNE', 'CENTRE-VAL DE LOIRE',
                        'CORSE', 'GRAND EST', 'HAUTS-DE-FRANCE', 'ÎLE-DE-FRANCE', 'NORMANDIE',
                        'NOUVELLE-AQUITAINE', 'OCCITANIE', 'PAYS DE LA LOIRE', 'PROVENCE-ALPES-CÔTE D\'AZUR'
                       ]; track r) {
                          <option [value]="r">{{ r }}</option>
                       }
                    </select>
                 </div>
              </div>
              <div>
                 <label class="field-label">{{ 'common.description' | translate }}</label>
                 <textarea [value]="currentEvent.description" (change)="updateEventInfo('description', $event)" rows="2"
                    class="field py-2"></textarea>
              </div>
              <fieldset class="rounded-xl border border-slate-200 p-4 dark:border-slate-600">
                <legend class="px-2 text-[10px] font-black uppercase tracking-widest text-slate-400">{{ 'common.structuredLocation' | translate }}</legend>
                <div class="grid grid-cols-1 gap-3 md:grid-cols-3">
                  <label class="field-label">{{ 'common.city' | translate }}
                    <input #geoCity type="text" [value]="currentEvent.city || ''"
                      class="field mt-1 py-2">
                  </label>
                  <label class="field-label">{{ 'common.department' | translate }}
                    <input #geoDepartment type="text" maxlength="3" [value]="currentEvent.departmentCode || ''"
                      class="field mt-1 py-2">
                  </label>
                  <label class="field-label">{{ 'common.postalCode' | translate }}
                    <input #geoPostal type="text" inputmode="numeric" maxlength="5" [value]="currentEvent.postalCode || ''"
                      class="field mt-1 py-2">
                  </label>
                  <label class="field-label md:col-span-3">{{ 'common.address' | translate }}
                    <input #geoAddress type="text" [value]="currentEvent.address || ''"
                      class="field mt-1 py-2">
                  </label>
                  <label class="field-label">{{ 'common.latitude' | translate }}
                    <input #geoLatitude type="number" step="any" [value]="currentEvent.latitude ?? ''"
                      class="field mt-1 py-2">
                  </label>
                  <label class="field-label">{{ 'common.longitude' | translate }}
                    <input #geoLongitude type="number" step="any" [value]="currentEvent.longitude ?? ''"
                      class="field mt-1 py-2">
                  </label>
                  <label class="field-label">{{ 'common.precision' | translate }}
                    <select #geoPrecision [value]="currentEvent.geoPrecision || ''"
                      class="field mt-1 py-2">
                      <option value="">{{ 'common.uncertain' | translate }}</option>
                      <option value="venue">{{ 'common.venueGps' | translate }}</option>
                      <option value="address">{{ 'common.preciseAddress' | translate }}</option>
                      <option value="city_center">{{ 'common.cityCenterApproximate' | translate }}</option>
                      <option value="postal_code">{{ 'common.postalCodeApproximate' | translate }}</option>
                    </select>
                  </label>
                </div>
                <button type="button"
                  (click)="saveEventLocation(geoCity.value, geoDepartment.value, geoPostal.value, geoAddress.value, geoLatitude.value, geoLongitude.value, geoPrecision.value)"
                  class="btn btn-primary mt-4">
                  {{ 'common.saveLocation' | translate }}
                </button>
              </fieldset>
           </div>
        } @else {
          <h1 class="profile-title" [class.text-white]="currentEvent.imageUrl"
            [class.text-slate-900]="!currentEvent.imageUrl" [class.dark:text-white]="!currentEvent.imageUrl">{{ currentEvent.name }}</h1>
          @if (regionalTheme.activeRegion(); as federation) {
            <span class="accent-soft mt-3 inline-flex rounded-full border px-3 py-1 text-[10px] font-black uppercase tracking-[0.16em]">
              {{ federation.code }} · {{ federation.name }}
            </span>
          }
          <p class="text-lg mt-3" [class.text-slate-300]="currentEvent.imageUrl"
            [class.text-slate-500]="!currentEvent.imageUrl" [class.dark:text-slate-400]="!currentEvent.imageUrl">{{
            formatEventLocation(currentEvent) }} - {{ formatDate(currentEvent.date) }}</p>
          @if (currentEvent.description) {
            <p class="mt-4 text-sm leading-relaxed" [class.text-slate-200]="currentEvent.imageUrl"
              [class.text-slate-600]="!currentEvent.imageUrl" [class.dark:text-slate-300]="!currentEvent.imageUrl">
              {{ currentEvent.description }}
            </p>
          }
        }
      </div>
    </div>
  </div>

  @if (hasUnofficialResults()) {
    <p role="status" class="mb-6 rounded-xl border border-amber-400/40 bg-amber-50 dark:bg-amber-950/40 p-4 text-amber-900 dark:text-amber-200">
      <strong>{{ 'raceDetail.unofficialTitle' | translate }}</strong> — {{ 'raceDetail.unofficialText' | translate }}
    </p>
  }

  @if (hasStructuredLocation()) {
    <section aria-labelledby="event-location-title"
      class="card mb-6 p-4 sm:p-5">
      <div class="flex flex-col gap-5 lg:flex-row">
        <div class="flex flex-col rounded-2xl bg-slate-50 p-5 dark:bg-slate-800/60 lg:flex-1">
          <div class="flex items-start justify-between gap-3">
            <div class="flex items-center gap-3">
              <span class="accent-soft flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl border">
                <svg class="h-6 w-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M12 21s7-4.35 7-11a7 7 0 10-14 0c0 6.65 7 11 7 11z" />
                  <circle cx="12" cy="10" r="2.5" stroke-width="2" />
                </svg>
              </span>
              <div>
                <p class="text-[10px] font-black uppercase tracking-[0.22em] text-slate-400">{{ 'common.location' | translate }}</p>
                <h3 id="event-location-title" class="mt-1 text-lg font-black text-slate-900 dark:text-white">
                  {{ formatEventLocation(currentEvent) }}
                </h3>
              </div>
            </div>
          </div>

          @if (currentEvent.address) {
            <p class="mt-4 text-sm leading-relaxed text-slate-600 dark:text-slate-300">
              {{ currentEvent.address }}
            </p>
          }

          @if (locationPrecisionLabel(); as precisionLabel) {
            <span class="mt-4 inline-flex w-fit items-center gap-1.5 rounded-full px-3 py-1 text-xs font-bold"
              [class.bg-emerald-100]="isExactLocation()" [class.text-emerald-700]="isExactLocation()"
              [class.dark:bg-emerald-500/15]="isExactLocation()" [class.dark:text-emerald-300]="isExactLocation()"
              [class.bg-amber-100]="!isExactLocation()" [class.text-amber-700]="!isExactLocation()"
              [class.dark:bg-amber-500/15]="!isExactLocation()" [class.dark:text-amber-300]="!isExactLocation()">
              <span class="h-1.5 w-1.5 rounded-full"
                [class.bg-emerald-500]="isExactLocation()" [class.bg-amber-500]="!isExactLocation()"></span>
              {{ precisionLabel }}
            </span>
          }

          <div class="mt-auto flex flex-wrap gap-2 pt-5">
            @if (externalMapUrl(); as mapUrl) {
              <a [href]="mapUrl" target="_blank" rel="noopener noreferrer"
                class="accent-focus inline-flex items-center gap-2 rounded-xl bg-slate-900 px-4 py-2.5 text-sm font-bold text-white transition-colors hover:bg-slate-700 dark:bg-white dark:text-slate-900 dark:hover:bg-slate-200">
                <svg class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M9 18l-6 3V6l6-3 6 3 6-3v15l-6 3-6-3zm0 0V3m6 18V6" />
                </svg>
                {{ 'common.viewOnMap' | translate }}
              </a>
            }
            @if (directionsUrl(); as routeUrl) {
              <a [href]="routeUrl" target="_blank" rel="noopener noreferrer"
                class="accent-solid inline-flex items-center gap-2 rounded-xl px-4 py-2.5 text-sm font-bold transition-colors">
                <svg class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M9 18l-6 3V6l6-3 6 3 6-3v15l-6 3-6-3zm0 0V3m6 18V6" />
                </svg>
                {{ 'common.directions' | translate }}
              </a>
            }
          </div>
        </div>

        @if (mapPoints().length > 0) {
          <div class="min-w-0 overflow-hidden rounded-3xl border border-slate-200 dark:border-slate-700 lg:flex-[2]">
            <app-event-map [points]="mapPoints()" [selectedEventId]="currentEvent.id"></app-event-map>
          </div>
        }
      </div>
    </section>
  }

  <!-- Event statistics: every result of the event, whatever the filters below -->
  @if (results().length > 0) {
  <section aria-labelledby="event-summary-title" class="card mb-6 p-5 text-slate-900 dark:text-white md:p-7">
    <h2 id="event-summary-title" class="section-title mb-2">{{ 'eventSummary.title' | translate }}</h2>
    <p class="text-sm text-slate-500 dark:text-slate-400 mb-6">{{ 'eventSummary.scope' | translate }}</p>
    <dl class="grid grid-cols-2 lg:grid-cols-4 gap-3 mb-7">
      <div class="rounded-2xl bg-slate-50 dark:bg-slate-800/60 p-4"><dt class="text-xs font-bold text-slate-500 dark:text-slate-400">{{ 'courseStats.participations' | translate }}</dt><dd class="text-3xl font-black mt-2">{{ eventSummary().total }}</dd></div>
      <div class="rounded-2xl bg-slate-50 dark:bg-slate-800/60 p-4"><dt class="text-xs font-bold text-slate-500 dark:text-slate-400">{{ 'courseStats.unique' | translate }}</dt><dd class="text-3xl font-black mt-2">{{ eventSummary().humans }}</dd></div>
      <div class="rounded-2xl bg-slate-50 dark:bg-slate-800/60 p-4"><dt class="text-xs font-bold text-slate-500 dark:text-slate-400">{{ 'eventSummary.dogs' | translate }}</dt><dd class="text-3xl font-black mt-2">{{ eventSummary().dogs }}</dd></div>
      <div class="rounded-2xl bg-slate-50 dark:bg-slate-800/60 p-4"><dt class="text-xs font-bold text-slate-500 dark:text-slate-400">{{ 'eventSummary.disciplines' | translate }}</dt><dd class="text-3xl font-black mt-2">{{ eventDisciplines().length }}</dd></div>
    </dl>
    <h3 class="font-bold mb-4">{{ 'courseStats.disciplines' | translate }}</h3>
    <ul class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-x-7 gap-y-4">
      @for (discipline of eventDisciplines(); track discipline.code) {
        <li>
          <div class="flex justify-between gap-3 text-sm mb-2"><span class="font-bold">{{ discipline.label }}</span><span>{{ discipline.count }} · {{ formatPercent(discipline.percent) }} %</span></div>
          <div class="h-2 rounded-full overflow-hidden bg-slate-100 dark:bg-slate-800" aria-hidden="true"><div class="h-full rounded-full accent-solid" [style.width.%]="discipline.percent"></div></div>
        </li>
      } @empty { <li class="text-sm text-slate-500 dark:text-slate-400">{{ 'courseStats.empty' | translate }}</li> }
    </ul>
    <p class="text-xs text-slate-500 dark:text-slate-400 mt-5">{{ 'eventSummary.countHint' | translate }}</p>
    @if (eventSummary().unidentified) { <p class="text-xs text-slate-500 dark:text-slate-400 mt-2">{{ 'courseStats.unidentified' | translate:eventSummary().unidentified }}</p> }
    @if (eventSummary().dnf || eventSummary().dns || eventSummary().dsq) {
      <div class="flex flex-wrap gap-4 border-t border-slate-100 dark:border-slate-700 mt-5 pt-4 text-sm">
        <span>{{ 'eventSummary.dnf' | translate }} : <strong>{{ eventSummary().dnf }}</strong></span>
        <span>{{ 'eventSummary.dns' | translate }} : <strong>{{ eventSummary().dns }}</strong></span>
        <span>{{ 'eventSummary.dsq' | translate }} : <strong>{{ eventSummary().dsq }}</strong></span>
      </div>
    }
    <app-runner-statistics [races]="contributionRaces()" />
  </section>
  }

  @if (results().length > 0 || isEditMode()) {
  <!-- Filters & Admin Tools -->
  <div class="card mb-6 p-4 sm:p-5">
    <div class="flex justify-between items-start">
        <div class="pt-4 flex-1">
          <p class="field-label">{{ 'raceDetail.quickFiltersTitle' | translate }}</p>
          <div class="flex flex-wrap gap-2 items-center">
            @for(filter of quickFilters(); track filter.value) {
            <button type="button" (click)="onQuickFilterChange(filter)" [attr.aria-pressed]="isFilterActive(filter)"
              class="px-3 py-1 text-xs font-semibold rounded-full transition-colors"
              [class.accent-solid]="isFilterActive(filter)" [class.text-white]="isFilterActive(filter)"
              [class.bg-slate-100]="!isFilterActive(filter)" [class.text-slate-700]="!isFilterActive(filter)"
              [class.hover:bg-slate-200]="!isFilterActive(filter)" [class.dark:bg-slate-800]="!isFilterActive(filter)"
              [class.dark:text-slate-200]="!isFilterActive(filter)"
              [class.dark:hover:bg-slate-700]="!isFilterActive(filter)">
              {{ filter.labelKey | translate }}
              @if(filter.distanceKm) {
                <span class="opacity-75 ml-0.5 text-[0.65rem] font-medium leading-none">({{ filter.distanceKm | distance }}km)</span>
              }
            </button>
            }
          </div>
        </div>
        
        @if (isAdmin()) {
            <div class="ml-4 mt-4 flex flex-wrap justify-end gap-2">
                <button type="button" (click)="toggleEditMode()" class="btn"
                    [class.btn-primary]="isEditMode()" [class.btn-secondary]="!isEditMode()">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                    </svg>
                    {{ isEditMode() ? ('common.finishEditing' | translate) : ('common.editMode' | translate) }}
                </button>
                <button type="button" (click)="toggleSourceDebug()" class="btn"
                    [class.btn-primary]="showSourceDebug()" [class.btn-secondary]="!showSourceDebug()">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.75 3.5h4.5M12 3.5v2m-5.5 2.75l1.5 1.5M17.5 8.25l1.5-1.5M4.5 13h2m11 0h2M7.5 18.25l1.5-1.5m8.5 0l1.5 1.5M12 18.5v2m0-5.5a3 3 0 100-6 3 3 0 000 6z" />
                    </svg>
                    {{ showSourceDebug() ? ('common.hideSources' | translate) : ('common.debugSources' | translate) }}
                </button>
            </div>
        }
    </div>

    <!-- Race Config Editor (Visible in Edit Mode) -->
    @if (isEditMode() && currentEvent.races) {
        <div class="mt-6 pt-4 border-t border-slate-200 dark:border-slate-600">
            <h3 class="text-sm font-bold text-slate-700 dark:text-slate-300 mb-3 uppercase tracking-wider">{{ 'admin.importRanking.form.distances' | translate }}</h3>
            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                @for (race of currentEvent.races; track race.id) {
                    <div class="bg-slate-50 dark:bg-slate-700/50 p-3 rounded border border-slate-200 dark:border-slate-600">
                        <div class="text-xs font-bold text-slate-500 mb-2">{{ race.name }}</div>
                        <div class="flex gap-2">
                             <select [value]="getRaceDisciplineValue(race)" (change)="updateRaceConfig(race.id, 'discipline', $event)"
                               class="field flex-1 rounded-lg px-2 py-1 text-xs">
                                @for (disc of disciplineOptions; track disc.code) {
                                <option [value]="disc.code">{{ disc.labelKey | translate }}</option>
                                }
                             </select>
                             <div class="relative w-24">
                                <input type="number" step="0.1" [value]="race.distanceKm" (change)="updateRaceConfig(race.id, 'distanceKm', $event)"
                                   class="field rounded-lg py-1 pl-2 text-xs">
                                <span class="absolute right-2 top-1 text-xs text-slate-400">km</span>
                             </div>
                        </div>
                    </div>
                }
            </div>
        </div>
    }

    <div class="pt-4 mt-4 border-t border-slate-100 dark:border-slate-800">
      <h2 class="section-title mb-4">{{ 'raceDetail.filtersTitle' | translate }}</h2>
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          <div>
            <label for="genderFilter" class="field-label">
              {{ 'rankings.gender' | translate }}
            </label>
            <select id="genderFilter" (change)="onGenderChange($event)" [value]="genderFilter()"
              class="field">
              <option value="ALL">{{ 'raceDetail.category.all' | translate }}</option>
              <option value="H">{{ 'raceDetail.category.male' | translate }}</option>
              <option value="F">{{ 'raceDetail.category.female' | translate }}</option>
            </select>
          </div>

          <div>
            <label for="disciplineSelectFilter" class="field-label">
              {{ 'common.discipline' | translate }}
            </label>
            <select id="disciplineSelectFilter" (change)="onDisciplineSelectChange($event)" [value]="disciplineFilter()"
              class="field">
              @if (quickFilters().length === 0) {
                <option value="ALL">{{ ('raceDetail.category.all' | translate) | uppercase }}</option>
              }
              @for (f of quickFilters(); track f.value) {
                @if (f.type === 'discipline') {
                  <option [value]="f.value">{{ f.labelKey | translate | uppercase }} {{ f.distanceKm ? '(' + (f.distanceKm | distance) + 'km)' : '' }}</option>
                }
              }
            </select>
          </div>

          <div>
            <label for="categoryFilter" class="field-label">
              {{ 'common.category' | translate }}
            </label>
            <select id="categoryFilter" (change)="onCategoryChange($event)" [value]="categoryFilter()"
              class="field">
              @for (cat of categories(); track cat) {
                <option [value]="cat">
                  {{ cat === 'ALL' ? ('raceDetail.category.all' | translate) : (categoryLabels[cat] || cat) }}
                </option>
              }
            </select>
          </div>
          <div>
            <label for="clubFilter" class="field-label">
              {{ 'common.club' | translate }}
            </label>
            <select id="clubFilter" (change)="onClubChange($event)" [value]="clubFilter()"
              class="field">
              @for (club of clubs(); track club) {
                <option [value]="club">{{ (club === 'ALL' ? ('raceDetail.category.all' | translate) : club) | uppercase }}</option>
              }
            </select>
          </div>

          <div>
            <label for="dogBreedFilter" class="field-label">
              {{ 'common.dogBreed' | translate }}
            </label>
            <select id="dogBreedFilter" (change)="onDogBreedChange($event)" [value]="dogBreedFilter()"
              class="field">
              @for (breed of dogBreeds(); track breed) {
                <option [value]="breed">{{ breed === 'ALL' ? ('raceDetail.category.all' | translate) : (breed | breedName) }}</option>
              }
            </select>
          </div>
      </div>
    </div>
  </div>

  <!-- Leaderboard & Skyscrapers -->
  <div class="grid grid-cols-1 lg:grid-cols-6 2xl:grid-cols-8 gap-6 items-start mt-8">
    <!-- Left Skyscraper -->
    <aside class="hidden lg:block lg:col-span-1 sticky top-8 space-y-6">
       <div class="flex flex-col gap-6">
        <!-- Summary Skyscraper -->
        <div class="accent-gradient rounded-3xl p-6 flex flex-col items-center text-center min-h-[400px]">
          <div class="w-12 h-12 rounded-2xl bg-white/20 backdrop-blur-md flex items-center justify-center mb-6">
            <svg class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
            </svg>
          </div>
          <h3 class="text-[10px] font-black uppercase tracking-[0.3em] mb-4 opacity-70">{{ 'rankings.sidebar.participants' | translate }}</h3>
          <p class="text-6xl font-black mb-auto">{{ filteredLeaderboard().length }}</p>
          <div class="w-full mt-6 pt-6 border-t border-white/10">
            <span class="text-[10px] font-black uppercase tracking-widest opacity-60 block mb-2">{{ 'raceDetail.stats.resultsCount' | translate }}</span>
            <span class="text-2xl font-black">{{ results().length }}</span>
          </div>
        </div>

        <!-- Club Skyscraper -->
        <div class="card flex min-h-[400px] flex-col p-6">
          <h3 class="text-[10px] font-black text-slate-400 uppercase tracking-[0.3em] mb-8 text-center">{{ 'rankings.sidebar.topClubs' | translate }}</h3>
          <div class="flex-1 space-y-4">
            @for (club of stats().topClubs; track club.name; let i = $index) {
              <div class="group relative flex flex-col items-center p-4 rounded-2xl bg-slate-50 dark:bg-slate-800/50 border border-slate-100 dark:border-slate-700/50 transition-all hover:scale-105">
                <span class="absolute -top-2 -left-2 w-6 h-6 rounded-lg accent-solid text-[10px] font-black flex items-center justify-center">#{{ i + 1 }}</span>
                <span class="text-xs font-bold text-slate-900 dark:text-slate-100 text-center line-clamp-2 mb-2 uppercase">{{ club.name }}</span>
                <span class="text-xl font-black text-accent">{{ club.count }}</span>
              </div>
            }
          </div>
        </div>
      </div>
    </aside>

    <!-- Main Leaderboard (Premium Style) -->
    <div class="lg:col-span-4 2xl:col-span-6">
      <div class="card overflow-hidden">
        <div class="overflow-x-auto">
          <table class="min-w-full divide-y divide-slate-100 dark:divide-slate-700">
            <thead class="bg-slate-50 dark:bg-slate-900/40">
              <tr>
                <th class="px-3 py-3 sm:px-6 sm:py-4 text-left text-[10px] font-black text-slate-400 uppercase tracking-widest w-[60px]">🏆</th>
                @if(isColumnVisible('federation')) { <th class="hidden md:table-cell px-3 py-3 sm:px-6 sm:py-4 text-left text-[10px] font-black text-slate-400 uppercase tracking-widest w-[80px]">{{ 'common.federation' | translate }}</th> }
                <th class="px-3 py-3 sm:px-6 sm:py-4 text-left text-[10px] font-black text-slate-400 uppercase tracking-widest">{{ 'admin.resultatsCourse.competitor' | translate }}</th>
                <th class="px-3 py-3 sm:px-6 sm:py-4 text-left text-[10px] font-black text-slate-400 uppercase tracking-widest w-[80px]">{{ 'common.category' | translate }}</th>
                <th class="px-3 py-3 sm:px-6 sm:py-4 text-left text-[10px] font-black text-slate-400 uppercase tracking-widest">{{ 'admin.resultatsCourse.details' | translate }}</th>
                <th class="px-3 py-3 sm:px-6 sm:py-4 text-right text-[10px] font-black text-slate-400 uppercase tracking-widest w-[100px]">{{ 'common.time' | translate }}</th>
                @if(showSourceDebug()) { <th class="px-4 py-4 text-left text-[10px] font-black text-slate-400 uppercase tracking-widest min-w-[230px]">{{ 'admin.resultatsCourse.sourceResult' | translate }}</th> }
                <th class="px-3 py-3 sm:px-6 sm:py-4 text-right text-[10px] font-black text-slate-400 uppercase tracking-widest w-[80px]">{{ 'resultColumns.speed' | translate }}</th>
                @if(isEditMode()) { <th class="px-4 py-4 w-10"></th> }
              </tr>
            </thead>
            <tbody class="divide-y divide-slate-50 dark:divide-slate-700/50">
              @for (res of filteredLeaderboard(); track res.id; let i = $index) {
                <tr class="group hover:bg-slate-50/80 dark:hover:bg-slate-700/30 transition-all duration-150">
                  <!-- Rank -->
                  <td class="px-3 py-3 sm:px-6 sm:py-4 whitespace-nowrap">
                    @if(!isEditMode()) {
                      @if(res.timeSeconds > 0) {
                        <span class="text-base font-black text-accent">#{{ res.position || (i + 1) }}</span>
                      } @else {
                        <span class="text-base font-black text-slate-400">—</span>
                      }
                    } @else {
                      <input type="number" [value]="res.position" (change)="updateResultField(res.id, 'position', $event)" 
                        class="w-12 text-center bg-slate-100 dark:bg-slate-800 rounded border-none p-1 text-accent font-black">
                    }
                  </td>

                  <!-- Federation -->
                  @if(isColumnVisible('federation')) {
                    <td class="hidden md:table-cell px-3 py-3 sm:px-6 sm:py-4 whitespace-nowrap text-sm">
                      <span class="accent-soft text-[10px] font-black px-2 py-1 rounded-md border uppercase">
                        {{ (res.category?.startsWith('V') && !res.category?.startsWith('V1')) ? 'FFSLC' : 'FFSLC' }}
                      </span>
                    </td>
                  }

                  <!-- Name -->
                  <td class="px-3 py-3 sm:px-6 sm:py-4 whitespace-nowrap text-sm">
                    @if(!isEditMode()) {
                      @if (res.team?.human?.id && res.team?.human?.name) {
                      <a [routerLink]="['/human-profile', res.team!.human.id]" class="flex flex-col group-hover:translate-x-1 transition-transform">
                        <span class="text-xs font-black text-slate-900 dark:text-slate-100 uppercase tracking-wide">
                          {{ res.team?.human?.name }} <app-registered-star [humanId]="res.team?.human?.id" />
                        </span>
                      </a>
                      } @else {
                        <span class="text-xs font-bold text-slate-400">{{ null | displayValue }}</span>
                      }
                    } @else {
                      @if (res.team?.human; as human) {
                      <input type="text" [value]="human.name" (change)="updateHumanName(human.id, $event)"
                        class="w-full bg-slate-100 dark:bg-slate-800 rounded border-none p-1 text-xs font-black uppercase">
                      }
                    }
                  </td>

                  <!-- Category -->
                  <td class="px-3 py-3 sm:px-6 sm:py-4 whitespace-nowrap text-sm">
                    @if(!isEditMode()) {
                      <span class="text-xs font-bold text-slate-500 dark:text-slate-400">{{ res.category | displayValue }} <span class="whitespace-nowrap">· @if (res.categoryRank && !res.statusCode) { #{{ res.categoryRank }} } @else { — }</span></span>
                    } @else {
                      <input type="text" [value]="res.category || ''" (change)="updateResultField(res.id, 'category', $event)"
                        class="w-14 text-center bg-slate-100 dark:bg-slate-800 rounded border-none p-1 text-xs font-bold">
                    }
                  </td>

                  <!-- Details -->
                  <td class="px-3 py-3 sm:px-6 sm:py-4">
                    <div class="flex flex-col gap-0.5">
                      @if(!isEditMode()) {
                        <span class="text-[10px] font-bold text-slate-400 uppercase truncate max-w-[200px]" [title]="res.team?.human?.club">
                          {{ res.team?.human?.club || ('clubsKiosk.independents' | translate) }}
                        </span>
                        <div class="flex items-center gap-1">
                          @if (res.team?.dog?.id && res.team?.dog?.name) {
                           <a [routerLink]="['/dog-profile', res.team!.dog.id]" class="text-[11px] font-black text-slate-600 dark:text-slate-300 uppercase italic hover:text-emerald-500 transition-colors">
                             {{ res.team?.dog?.name }}
                           </a>
                           @if (res.team?.dog?.breed) {
                             <span class="text-[9px] text-slate-400 font-medium">({{ res.team?.dog?.breed | breedName }})</span>
                           }
                          } @else {
                            <span class="text-[11px] font-bold text-slate-400">{{ null | displayValue }}</span>
                          }
                        </div>
                      } @else {
                        @if (res.team?.human; as human) {
                        <app-club-picker class="block mb-1" [clubName]="human.club" [ariaLabel]="'common.club' | translate"
                          inputClass="w-full bg-slate-100 dark:bg-slate-800 rounded border-none p-0.5 text-[10px] font-bold"
                          (clubChange)="updateHumanClub(human.id, $event)" />
                        }
                        @if (res.team?.dog; as dog) {
                        <div class="flex gap-1">
                          <input type="text" [value]="dog.name" (change)="updateDogField(dog.id, 'name', $event)"
                            class="w-1/2 bg-slate-100 dark:bg-slate-800 rounded border-none p-0.5 text-[10px] font-black" [placeholder]="'common.dog' | translate">
                          <input type="text" [value]="dog.breed" (change)="updateDogField(dog.id, 'breed', $event)"
                            class="w-1/2 bg-slate-100 dark:bg-slate-800 rounded border-none p-0.5 text-[10px] text-slate-500" [placeholder]="'common.race' | translate">
                        </div>
                        }
                      }
                    </div>
                  </td>

                  <!-- Temps -->
                  <td class="px-3 py-3 sm:px-6 sm:py-4 text-right whitespace-nowrap text-sm">
                    @if(!isEditMode()) {
                      @if(res.timeSeconds > 0) {
                        <span class="font-mono text-sm font-black text-emerald-500 bg-emerald-50 dark:bg-emerald-500/10 px-2.5 py-1 rounded-lg border border-emerald-100 dark:border-emerald-500/20">
                          {{ formatTime(res.timeSeconds) }}
                        </span>
                      } @else if(res.statusLabel) {
                        <span
                          class="inline-flex rounded-lg border px-2.5 py-1 text-[11px] font-black uppercase tracking-wide"
                          [class.border-rose-200]="res.statusCode === 'dnf' || res.statusCode === 'dsq' || res.statusCode === 'dns'"
                          [class.bg-rose-50]="res.statusCode === 'dnf' || res.statusCode === 'dsq' || res.statusCode === 'dns'"
                          [class.text-rose-600]="res.statusCode === 'dnf' || res.statusCode === 'dsq' || res.statusCode === 'dns'"
                          [class.border-amber-200]="res.statusCode !== 'dnf' && res.statusCode !== 'dsq' && res.statusCode !== 'dns'"
                          [class.bg-amber-50]="res.statusCode !== 'dnf' && res.statusCode !== 'dsq' && res.statusCode !== 'dns'"
                          [class.text-amber-700]="res.statusCode !== 'dnf' && res.statusCode !== 'dsq' && res.statusCode !== 'dns'"
                          [title]="res.statusRaw || res.statusLabel">
                          {{ res.statusCode ? (res.statusCode | resultStatus:res.statusLabel:res.statusRaw) : res.statusLabel }}
                        </span>
                      } @else {
                        <span class="font-mono text-sm font-black text-slate-400">—</span>
                      }
                    } @else {
                      <input type="text" [value]="formatTime(res.timeSeconds)" (change)="updateResultField(res.id, 'timeSeconds', $event)"
                        class="w-24 text-right bg-slate-100 dark:bg-slate-800 rounded border-none p-1 font-mono text-sm font-black text-emerald-500">
                    }
                  </td>

                  <!-- Source debug (admin only) -->
                  @if(showSourceDebug()) {
                    <td class="px-4 py-4 text-left text-xs">
                      <div class="flex flex-col gap-1" [title]="getResultSourceTitle(res)">
                        @if(res.sourceUrl; as sourceUrl) {
                          <a [href]="sourceUrl" target="_blank" rel="noopener noreferrer"
                            class="inline-flex w-fit items-center gap-1 font-black text-amber-600 hover:text-amber-500 dark:text-amber-400 dark:hover:text-amber-300">
                            {{ getResultSourceLabel(res) }}
                            <span aria-hidden="true">↗</span>
                          </a>
                        } @else {
                          <span class="font-black text-slate-500 dark:text-slate-300">{{ getResultSourceLabel(res) }}</span>
                        }
                        <span class="max-w-[260px] truncate font-mono text-[10px] text-slate-400">
                          {{ res.sourceRecordKey || ('admin.resultatsCourse.sourceKeyMissing' | translate) }}
                        </span>
                      </div>
                    </td>
                  }

                  <!-- Average speed -->
<td class="py-3 px-4 text-right whitespace-nowrap text-sm font-bold text-emerald-600 dark:text-emerald-400">{{ resultSpeed(res) }}</td>

                  <!-- Admin Trash -->
                  @if(isEditMode()) {
                    <td class="px-4 py-4 text-center">
                      <button (click)="deleteResultRow(res.id)" class="text-slate-400 hover:text-red-500 transition-colors">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                        </svg>
                      </button>
                    </td>
                  }
                </tr>
              } @empty {
                <tr>
                  <td colspan="20" class="px-6 py-20 text-center">
                    <div class="flex flex-col items-center opacity-30">
                      <svg class="w-12 h-12 mb-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M9.172 9.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                      <p class="text-xs font-black uppercase tracking-widest">{{ 'raceDetail.noResults' | translate }}</p>
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- Right Skyscraper -->
    <aside class="hidden lg:block lg:col-span-1 sticky top-8 space-y-6">
      <div class="flex flex-col gap-6">
        <!-- Breeds Skyscraper -->
        <div class="card flex min-h-[400px] flex-col p-6">
          <h3 class="text-[10px] font-black text-slate-400 uppercase tracking-[0.3em] mb-8 text-center">{{ 'rankings.sidebar.topBreeds' | translate }}</h3>
          <div class="flex-1 space-y-4">
            @for (breed of stats().topBreeds; track breed.name) {
              <div class="flex flex-col p-4 rounded-2xl bg-slate-50 dark:bg-slate-800/50 border border-slate-100 dark:border-slate-700/50 transition-all hover:scale-105">
                <span class="text-xs font-black text-slate-900 dark:text-slate-300 uppercase leading-tight break-words mb-1" [title]="breed.name">{{ breed.name }}</span>
                <span class="text-2xl font-black text-accent">{{ breed.count }}</span>
              </div>
            }
          </div>
        </div>

        <!-- Disciplines Skyscraper -->
        <div class="card flex min-h-[400px] flex-col p-6">
          <h3 class="text-[10px] font-black text-slate-400 uppercase tracking-[0.3em] mb-8 text-center">{{ 'rankings.sidebar.disciplines' | translate }}</h3>
          <div class="flex-1 space-y-6">
            @for (disc of stats().disciplineStats; track disc.name) {
              <div class="flex flex-col px-2">
                <div class="flex justify-between items-end mb-2">
                  <span class="text-[9px] font-black text-slate-500 uppercase tracking-wider leading-tight break-words min-w-0 flex-1" [title]="getDisciplineDisplayName(disc.name)">{{ getDisciplineDisplayName(disc.name) }}</span>
                  <span class="text-xs font-black text-accent">{{ disc.count }}</span>
                </div>
                <div class="w-full h-1.5 bg-slate-100 dark:bg-slate-800 rounded-full overflow-hidden">
                  <div class="h-full bg-[var(--region-accent)] rounded-full" [style.width.%]="(disc.count / results().length) * 100"></div>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </aside>
  </div>
  } @else {
  <section class="card mt-8 flex flex-col items-center px-6 py-16 text-center">
    <span class="accent-soft mb-4 flex h-14 w-14 items-center justify-center rounded-2xl border" aria-hidden="true">
      <svg class="h-7 w-7" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
    </span>
    <h2 class="section-title mb-2">{{ 'raceDetail.resultsPendingTitle' | translate }}</h2>
    <p class="max-w-md text-sm text-slate-500 dark:text-slate-400">{{ 'raceDetail.resultsPendingHint' | translate }}</p>
  </section>
  }

  @if (currentEvent.eventPhotos && currentEvent.eventPhotos.length > 0) {
    <div class="mt-8">
      <app-image-gallery [images]="currentEvent.eventPhotos"></app-image-gallery>
    </div>
  }

  } @else if (isLoading()) {
    <app-branded-loader [label]="'raceDetail.loading' | translate" />
  } @else {
    <div class="py-32 text-center">
      <h1 class="text-xl font-black text-slate-900 dark:text-white uppercase tracking-widest mb-2">{{ 'common.eventNotFound' | translate }}</h1>
      <p class="text-slate-500 dark:text-slate-400 font-medium mb-8">{{ 'common.eventNotPublished' | translate }}</p>
      <a routerLink="/races" class="btn btn-primary">
        {{ 'common.viewAllResults' | translate }}
      </a>
    </div>
  }
</div>
